import PropTypes from 'prop-types';
import React from 'react';
import { formatPhoneNumber } from '@atc/string-fns';

/**
 *  The phone number component will accept an integer and run it through the formatPhoneNumber utility
 *
 */
function PhoneNumber(_ref) {
  let {
    phoneNumber,
    extension,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("span", Object.assign({
    "data-cmp": "phoneNumber"
  }, rest), formatPhoneNumber(phoneNumber, extension));
}
export default PhoneNumber;